/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type PayPeriodType = typeof PayPeriodType[keyof typeof PayPeriodType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayPeriodType = {
  PayPeriodTypeBiweekly: 'biweekly',
  PayPeriodTypeMonthly: 'monthly',
} as const;
